import React from 'react';
import { Source, Layer } from 'react-map-gl/maplibre';
import { MAP_FONT_STACK_BOLD } from '../../lib/map-styles';

const COLOR = ['match', ['get', 'source'], 'db', '#34d399', '#fbbf24'];

/** Highlight layers for the Find nearest tool: connectors, hits with distance labels, click point. */
export default function NearestLayers({ nearest }) {
  if (!nearest || !nearest.point) return null;
  return (
    <Source id="nearest-src" type="geojson" data={nearest.geojson}>
      <Layer id="nearest-links" type="line" filter={['==', ['get', 'role'], 'link']}
        paint={{ 'line-color': COLOR, 'line-width': 1.5, 'line-dasharray': [3, 2], 'line-opacity': 0.8 }} />
      <Layer id="nearest-halo" type="circle" filter={['==', ['get', 'role'], 'hit']}
        paint={{ 'circle-radius': 11, 'circle-color': COLOR, 'circle-opacity': 0.25 }} />
      <Layer id="nearest-hits" type="circle" filter={['==', ['get', 'role'], 'hit']}
        paint={{ 'circle-radius': 5, 'circle-color': COLOR, 'circle-stroke-color': '#0d1117', 'circle-stroke-width': 1.5 }} />
      <Layer id="nearest-origin" type="circle" filter={['==', ['get', 'role'], 'origin']}
        paint={{ 'circle-radius': 4, 'circle-color': '#fff', 'circle-stroke-color': '#0d1117', 'circle-stroke-width': 2 }} />
      <Layer id="nearest-labels" type="symbol" filter={['==', ['get', 'role'], 'hit']}
        layout={{ 'text-field': ['get', 'label'], 'text-font': MAP_FONT_STACK_BOLD, 'text-size': 11, 'text-offset': [0, -1.4], 'text-anchor': 'bottom', 'text-allow-overlap': true }}
        paint={{ 'text-color': '#fff', 'text-halo-color': '#0d1117', 'text-halo-width': 1.5 }} />
    </Source>
  );
}
